import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppState } from '../state/AppState';
import BackButton from '../components/BackButton';
import ProgressBar from '../components/ProgressBar';
import ReservationTimer from '../components/ReservationTimer';
import ProviderImage from '../components/ProviderImage';
import { getProviderNameFromAvailability } from '../services/availabilityDataService';
import { formatSessionDate } from '../utils/dateUtils';

/**
 * ScreenO - Appointment summary and acceptance screen.
 *
 * Shows the user a summary of their appointment and allows them to accept and proceed.
 */
const ScreenO: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useAppState();

  // Use provider name from availability data, fallback to preferred provider
  const providerName = getProviderNameFromAvailability(state.availabilities, null);
  
  // Get session rate from selected availability based on service type
  const getSessionRate = (): string => {
    const fallbackRate = 'Please call (425) 640-7009 for rate.';
    
    if (!state.selectedAvailability) {
      return fallbackRate;
    }
    
    const availability = state.selectedAvailability as any; // Type assertion for pricing properties
    const service = state.service;
    
    // Check service type and use appropriate pricing
    if (service === 'Individual Therapy' && availability.privatePayIndividualTherapy) {
      return availability.privatePayIndividualTherapy;
    } else if ((service === 'Couples Therapy' || service === 'Family Therapy') && availability.privatePayCouplesFamily) {
      return availability.privatePayCouplesFamily;
    }
    
    return fallbackRate;
  };
  
  const sessionRate = getSessionRate();
  const sessionDate = formatSessionDate(state.appointmentDate);
  const sessionTime = state.appointmentTime || '12pm – 1pm';
  const sessionLocation = state.location || 'Northgate Office';

  return (
    <div className="screen-bg">
      <div className="main-content-container">
        <div className="mtg-back-btn-align">
          <BackButton onClick={() => navigate(-1)} />
        </div>
        <main className="mtg-screen-main">
          <div className="mtg-screen-card mb-18 text-center" style={{ borderRadius: 16, overflow: 'hidden', paddingTop: 8 }}>
            {state.reservationStartTime && (
              <div className="text-soft" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', fontSize: '1.05rem', fontWeight: 500 }}>
                <ReservationTimer 
                  style={{ color: '#b5b5b5', fontWeight: 400 }}
                />
              </div>
            )}
            <div style={{ padding: 0, background: '#fff', borderRadius: 16, minWidth: 260 }}>
              <ProviderImage className="mb-18 mt-12 d-block" maxWidth={320} maxHeight={320} style={{ margin: '0 auto' }} />
                      <h3 className="mb-2" style={{ fontWeight: 700, fontSize: '2rem', color: '#185F93' }}>{providerName}</h3>
        <div className="mb-16" style={{ color: '#185F93', fontWeight: 700, fontSize: '1.3rem' }}>Self Pay Rate</div>
              <div className="mb-12 text-soft" style={{ fontWeight: 500, fontSize: '1.0rem' }}>{sessionRate}</div>
              <hr style={{ border: 'none', borderTop: '2px solid rgb(216, 220, 223)', margin: '0 0 18px 0' }} />
              <div className="mb-2 text-soft" style={{ fontSize: '1.0rem' }}>{sessionDate}</div>
              <div className="mb-2 text-soft" style={{ fontSize: '1.0rem' }}>{sessionTime}</div>
              <div className="mb-18 text-soft" style={{ fontSize: '1.0rem' }}>{sessionLocation}</div>
            </div>
            <button
                className="pill-btn-standard"
                onClick={() => navigate('/p')}
              >
                Accept
              </button>
            <ProgressBar progress={90}/>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ScreenO; 